var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "stand-pagination-table",
      attrs: {
        role: "table",
        "aria-rowcount": _vm.ariaRowCount,
        "aria-colcount": _vm.ariaColCount,
      },
    },
    [
      _vm.showToolbar
        ? _c("div", { staticClass: "table-toolbar" }, [
            _c(
              "div",
              { staticClass: "toolbar-left" },
              [
                _vm.enableRefresh
                  ? _c(
                      "Button",
                      {
                        attrs: {
                          type: "default",
                          size: "small",
                          disabled: _vm.refreshRemainingMs > 0,
                        },
                        on: { click: _vm.handleRefreshClick },
                      },
                      [
                        _vm._v("\n                刷新"),
                        _vm.refreshRemainingMs > 0
                          ? _c("span", [
                              _vm._v(
                                "（" +
                                  _vm._s(
                                    Math.ceil(_vm.refreshRemainingMs / 1000)
                                  ) +
                                  "s）"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "toolbar-right" },
              [
                _vm.enableVxeVirtual
                  ? _c(
                      "div",
                      { staticClass: "virtual-toggle" },
                      [
                        _c("span", { staticClass: "virtual-toggle-label" }, [
                          _vm._v("虚拟滚动"),
                        ]),
                        _c("i-switch", {
                          attrs: {
                            size: "small",
                            value: _vm.virtualSwitchValue,
                            disabled: !_vm.virtualSwitchAvailable,
                          },
                          on: { "on-change": _vm.handleVirtualToggle },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.enableExport
                  ? _c(
                      "Dropdown",
                      { attrs: { placement: "bottom-end", transfer: "" } },
                      [
                        _c(
                          "Button",
                          { attrs: { type: "default", size: "small" } },
                          [
                            _vm._v(
                              "\n                    导出\n                    "
                            ),
                            _c("Icon", { attrs: { type: "ios-arrow-down" } }),
                          ],
                          1
                        ),
                        _c(
                          "DropdownMenu",
                          { attrs: { slot: "list" }, slot: "list" },
                          [
                            _c(
                              "DropdownItem",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.exportCsv.apply(null, arguments)
                                  },
                                },
                              },
                              [_vm._v("导出 CSV")]
                            ),
                            _c(
                              "DropdownItem",
                              {
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.exportExcel.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("导出 Excel")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.enableColumnVisibility
                  ? _c(
                      "Button",
                      {
                        attrs: { type: "default", size: "small" },
                        on: {
                          click: function ($event) {
                            _vm.columnDrawerVisible = true
                          },
                        },
                      },
                      [_vm._v("\n                列设置\n            ")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "main-table-wrapper",
          attrs: {
            id: "main",
            tabindex: "0",
            "aria-busy": _vm.loading ? "true" : "false",
          },
          on: { keydown: _vm.handleKeydown },
        },
        [
          _vm.useVxeVirtual
            ? _c("OptimizedVxeTable", {
                ref: "vxeMainTable",
                attrs: {
                  columns: _vm.processedColumns,
                  data: _vm.data,
                  loading: _vm.loading,
                  size: _vm.size,
                  "ext-height": _vm.extHeight,
                  "auto-height": _vm.autoHeight,
                  pagination: _vm.vxePagination,
                  "page-size-options": _vm.pageSizeOptions,
                  "show-page": _vm.showPage,
                },
                on: {
                  "page-change": _vm.handleVxePageChange,
                  "selection-change": _vm.handleSelectionChange,
                  "row-dblclick": _vm.handleVxeRowDblClick,
                },
              })
            : _c("Table", {
                ref: "mainTable",
                attrs: {
                  columns: _vm.processedColumns,
                  data: _vm.data,
                  loading: false,
                  size: _vm.size,
                  border: true,
                  stripe: true,
                  height: _vm.tableHeight,
                  "row-class-name": _vm.rowClassName,
                },
                on: {
                  "on-select": _vm.handleSelect,
                  "on-selection-change": _vm.handleSelectionChange,
                  "on-row-dblclick": _vm.handleRowDblClick,
                  "on-column-width-resize": _vm.handleColumnWidthResize,
                },
              }),
          _vm.showSkeleton
            ? _c(
                "div",
                {
                  staticClass: "table-skeleton",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "skeleton-row skeleton-header" },
                    _vm._l(_vm.ariaColCount, function (n) {
                      return _c("div", {
                        key: `h_${n}`,
                        staticClass: "skeleton-cell",
                      })
                    }),
                    0
                  ),
                  _vm._l(_vm.skeletonRowCount, function (r) {
                    return _c(
                      "div",
                      { key: `r_${r}`, staticClass: "skeleton-row" },
                      _vm._l(_vm.ariaColCount, function (n) {
                        return _c("div", {
                          key: `c_${r}_${n}`,
                          staticClass: "skeleton-cell",
                        })
                      }),
                      0
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm.showEmpty
            ? _c(
                "div",
                {
                  staticClass: "table-empty",
                  attrs: { role: "status", "aria-live": "polite" },
                },
                [
                  _vm._t("empty", function () {
                    return [
                      _c("div", {
                        staticClass: "empty-illustration",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._m(0),
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.handleRefreshClick },
                        },
                        [_vm._v("刷新")]
                      ),
                    ]
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSummary,
              expression: "showSummary",
            },
          ],
          staticClass: "summary-table-wrapper",
          attrs: { id: "summary" },
        },
        [
          _c("Table", {
            ref: "summaryTable",
            staticClass: "summary-table",
            attrs: {
              columns: _vm.summaryColumns,
              data: _vm.summaryData,
              size: _vm.size,
              "show-header": false,
              stripe: true,
              border: true,
            },
          }),
        ],
        1
      ),
      _vm.showPage && !_vm.useVxeVirtual
        ? _c("Page", {
            staticClass: "pagination",
            attrs: {
              total: _vm.total,
              "page-size": _vm.pageSize,
              current: _vm.current,
              "page-size-opts": _vm.pageSizeOptions,
              size: "small",
              "show-elevator": "",
              "show-sizer": "",
              "show-total": "",
              placement: "top",
              "aria-label": "分页",
            },
            on: {
              "on-change": _vm.onPageChange,
              "on-page-size-change": _vm.onPageSizeChange,
            },
          })
        : _vm._e(),
      _c(
        "Drawer",
        {
          attrs: {
            title: "列设置",
            placement: "right",
            width: "320",
            "mask-closable": true,
          },
          model: {
            value: _vm.columnDrawerVisible,
            callback: function ($$v) {
              _vm.columnDrawerVisible = $$v
            },
            expression: "columnDrawerVisible",
          },
        },
        [
          _c("div", { staticClass: "column-setting" }, [
            _c(
              "div",
              { staticClass: "column-setting-actions" },
              [
                _c(
                  "Button",
                  {
                    attrs: {
                      size: "small",
                      type: "default",
                      disabled: _vm.isAllVisible,
                    },
                    on: { click: _vm.setAllVisible },
                  },
                  [_vm._v("全选")]
                ),
                _c(
                  "Button",
                  {
                    attrs: {
                      size: "small",
                      type: "default",
                      disabled: _vm.isNoneVisible,
                    },
                    on: { click: _vm.setNoneVisible },
                  },
                  [_vm._v("反选")]
                ),
                _c(
                  "Button",
                  {
                    attrs: { size: "small", type: "default" },
                    on: { click: _vm.resetVisibility },
                  },
                  [_vm._v("重置")]
                ),
                _c(
                  "Button",
                  {
                    attrs: { size: "small", type: "default" },
                    on: { click: _vm.resetWidths },
                  },
                  [_vm._v("重置列宽")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "column-setting-list" },
              _vm._l(_vm.allColumnsForSetting, function (c) {
                return _c(
                  "Checkbox",
                  {
                    key: c.key,
                    attrs: { value: _vm.visibleKeySet.has(c.key) },
                    on: { "on-change": () => _vm.toggleVisible(c.key) },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(c.title) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "empty-text" }, [
      _c("div", { staticClass: "empty-title" }, [_vm._v("暂无数据")]),
      _c("div", { staticClass: "empty-subtitle" }, [
        _vm._v("请调整筛选条件或刷新重试"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }